import React from "react";
import { Button, Table } from "react-bootstrap";

import "./CompareTable.sass";

function CompareTable({
  title,
  choices,
  currentValue,
  handleSelect,
  compareChoiceAxis = "auto"
}) {
  const statFields = [
    ...new Set(
      choices.reduce((prev, curr) => {
        if (curr.hasOwnProperty("stats")) {
          return [...prev, ...Object.keys(curr.stats)];
        } else {
          return prev;
        }
      }, [])
    )
  ];

  let flipAxis = false;
  if (compareChoiceAxis === "auto" && choices.length > statFields.length) {
    flipAxis = true;
  } else if (compareChoiceAxis === "y") {
    flipAxis = true;
  }

  let table;
  if (flipAxis) {
    table = (
      <Table size="sm" className="flipped" striped hover bordered>
        <thead>
          <tr>
            <th>{title}</th>
            {statFields.map(field => (
              <th key={`stat-${field}`}>{field}</th>
            ))}
            <th />
          </tr>
        </thead>
        <tbody>
          {choices.map(choice => (
            <tr
              key={`choice-${choice.value}`}
              className={currentValue === choice.value ? "table-active" : ""}
            >
              <th>
                {choice.image && <img src={choice.image} alt={choice.label} />}
                {choice.label}
              </th>
              {statFields.map(field => (
                <td key={`field-${field}-${choice.value}`}>
                  {choice.hasOwnProperty("stats") && choice.stats[field]
                    ? choice.stats[field]
                    : "-"}
                </td>
              ))}
              <td key={`${choice.value}-selector`}>
                {currentValue === choice.value ? (
                  <span
                    className="d-inline-block"
                    style={{ padding: "6px 4px" }}
                  >
                    Selected
                  </span>
                ) : (
                  <Button
                    size="sm"
                    variant="outline-primary"
                    onClick={() => handleSelect(choice.value)}
                  >
                    Select
                  </Button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    );
  } else {
    table = (
      <Table size="sm" striped hover bordered>
        <thead>
          <tr>
            <th>{title}</th>
            {choices.map(choice => (
              <th key={`choice-${choice.value}`}>
                {choice.image && <img src={choice.image} alt={choice.label} />}
                <br />
                {choice.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {statFields.map(field => (
            <tr key={`field-${field}`}>
              <th>{field}</th>
              {choices.map(choice => (
                <td key={`field-${field}-${choice.value}`}>
                  {choice.hasOwnProperty("stats") && choice.stats[field]
                    ? choice.stats[field]
                    : "-"}
                </td>
              ))}
            </tr>
          ))}
          <tr key="selectors">
            <td />
            {choices.map(choice => (
              <td key={`${choice.value}-selector`}>
                <Button
                  size="sm"
                  variant="outline-primary"
                  disabled={currentValue === choice.value}
                  onClick={() => handleSelect(choice.value)}
                >
                  {currentValue === choice.value ? "Selected" : "Select"}
                </Button>
              </td>
            ))}
          </tr>
        </tbody>
      </Table>
    );
  }

  return <div className="workarea-select-compare">{table}</div>;
}

export default CompareTable;
